let capabilities;
const readCapabilities=url=>capabilities??=fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
    .then(async response=>response.ok&&(response.headers.get('Content-Type')||'').includes('application/json')?response.json():null)
    .then(result=>result?.success===true&&result.data?.readiness?.enabled===true).catch(()=>false);
export function mountEntryLinks(root,{capabilitiesUrl,context,studioUrl}) {
    let disposed=false;root.replaceChildren();
    if(!/^\/[a-zA-Z0-9/_-]+$/.test(capabilitiesUrl)||!/^\/[a-zA-Z0-9/_-]+$/.test(studioUrl))return()=>{};
    readCapabilities(capabilitiesUrl).then(allowed=>{if(disposed)return;root.dataset.entryReady='1';if(!allowed)return;const link=document.createElement('a');link.className='ms-button ms-button--secondary';link.textContent='Utwórz post';link.href=studioUrl+'?'+new URLSearchParams({entry:JSON.stringify(context)});root.append(link);});
    return()=>{disposed=true;root.replaceChildren();};
}
function mountAll(){
    for(const root of document.querySelectorAll('[data-social-entry]')){
        try{const dispose=mountEntryLinks(root,{capabilitiesUrl:root.dataset.capabilitiesUrl,studioUrl:root.dataset.studioUrl,context:JSON.parse(root.dataset.socialEntry)});window.addEventListener('pagehide',dispose,{once:true});}catch{root.replaceChildren();}
    }
}
mountAll();
window.addEventListener('pageshow',event=>{if(event.persisted){capabilities=undefined;mountAll();}});
